var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { CloseOutlined } from '@feb-team/legao-icons-react';
import classNames from 'classnames';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
var Notice = /** @class */ (function (_super) {
    __extends(Notice, _super);
    function Notice(props) {
        var _this = _super.call(this, props) || this;
        _this.isRef = false;
        _this.noticeTimer = null;
        _this.state = {
            value: true,
        };
        return _this;
    }
    Notice.prototype.componentDidMount = function () {
        var duration = this.props.duration;
        this.startTimer();
    };
    Notice.prototype.startTimer = function () {
        var _this = this;
        var duration = this.props.duration;
        if (0 !== duration) {
            this.noticeTimer = window.setTimeout(function () {
                _this.close();
            }, duration);
        }
    };
    Notice.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.duration !== this.props.duration) {
            this.startTimer();
        }
    };
    Notice.prototype.closeTimer = function () {
        if (this.noticeTimer) {
            clearTimeout(this.noticeTimer);
        }
    };
    Notice.prototype.close = function () {
        this.setState({
            value: false,
        });
    };
    Notice.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, prefixCls = _a.prefixCls, closeable = _a.closeable, className = _a.className, textAlign = _a.textAlign, onClick = _a.onClick, style = _a.style, closeAnimation = _a.closeAnimation, startAnimation = _a.startAnimation, atomics = _a.atomics;
        var value = this.state.value;
        return (React.createElement(DivTag, { atomics: [textAlign], name: Notice.NAME, className: Notice.NAME + "-" + prefixCls + " " },
            React.createElement(DivTag, { style: __assign({}, style), onClick: onClick, onMouseEnter: this.closeTimer.bind(this), onMouseLeave: this.startTimer.bind(this), ref: function (notice) {
                    if (!_this.isRef) {
                        _this.isRef = true;
                        notice.addEventListener('animationend', function (e) {
                            var _a, _b;
                            if (!_this.state.value) {
                                (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.onClose) === null || _b === void 0 ? void 0 : _b.call(_a, _this.props.noticeKey);
                            }
                        });
                    }
                }, atomics: __spread(['relative'], atomics), className: classNames({ 'legao-notice-close': closeable }, [
                    'legao-notice',
                    value ? startAnimation : closeAnimation,
                    className,
                ]) },
                children,
                closeable && (React.createElement(SpanTag, { atomics: 'absolute', className: "legao-notice-closeicon " },
                    React.createElement(CloseOutlined, { onClick: this.close.bind(this) }))))));
    };
    Notice.NAME = 'notice';
    Notice.defaultProps = { closeable: false, textAlign: '' };
    return Notice;
}(PureComponent));
export default Notice;
